<template>
    <div>
        <rkm-modal
            extraLarge
            ref="RkmModal"
            v-bind:title="'Adicionar procedimento(s) para cidadão: ' + item.nome + (item.nomeSocial ? ' ['+ item.nomeSocial +']' : '')"
        >
            <rkm-form
                ref="Form"
                show-legend
            >
                <rkm-row>
                    <rkm-col class="col-11">
                        <rkm-form-input-autocomplete
                            :repository="repositories.procedimento"
                            :request-query-string-params="autocompletesRequestParams.procedimento.queryString"
                            :search-fields="field.autocompletes.procedimento"
                            :text-field="p => `${this.formatProcedimento(p.codigo)} - ${p.nome}`"
                            :validations="validations.procedimento"
                            name="Procedimento"
                            v-model="model.procedimentoIndividual"
                        >
                        </rkm-form-input-autocomplete>
                    </rkm-col>

                    <rkm-col class="text-right">
                        <rkm-button
                            @click="save"
                            color="primary"
                        >
                            Incluir
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
                
                <rkm-row class="mt-2">
                    <rkm-col cols="12">

                        <rkm-table
                            :fields="fields"
                            :items="items"
                            sort-by="nome"
                            hide-filters
                        >
                            <template v-slot:cell(codigo)="row">
                                {{ row.value | formatProcedimento }}
                            </template>

                            <template v-slot:cell(procedimento)>
                                <rkm-button
                                    @click="$refs.ModalParticipante.open(row.nome, row.id)"
                                    class="mr-2"
                                    color="secondary"
                                    small
                                >
                                    <rkm-icon icon="plus" />
                                </rkm-button>
                            </template>

                            <template v-slot:cell(actions)="{ index }">

                                <rkm-button
                                    @click="destroy(index)"
                                    color="danger"
                                    small
                                    title="Excluir"
                                >
                                    <rkm-icon icon="trash" />
                                </rkm-button>
                            </template>
                        </rkm-table>
                    </rkm-col>
                </rkm-row>
            </rkm-form>

            <template v-slot:footer>
                <rkm-button @click="handleCancel">
                    Fechar
                </rkm-button>
            </template>
        </rkm-modal>
    </div>
</template>

<script>
// Moment.
import moment from 'moment'

//Enums
import procedimento from '@/enums/sigtap/procedimento'

// Mixins.
import { repository, stringCase, object, formats } from '@/mixins'

export default {
    computed: {
        autocompletesRequestParams() {

            const cid1 = this.data.model.atendimento && this.data.model.atendimento.cid1
                ? this.data.model.atendimento.cid1.id : null

            const cid2 = this.data.model.atendimento && this.data.model.atendimento.cid2
                ? this.data.model.atendimento.cid2.id : null

            const ciapCid1 = this.data.model.atendimento && this.data.model.atendimento.ciap1
                ? this.data.model.atendimento.ciap1.cidId : null

            const ciapCid2 = this.data.model.atendimento && this.data.model.atendimento.ciap2
                ? this.data.model.atendimento.ciap2.cidId : null

            let cidId = cid1 ? cid1 : ''

            if (cidId == '') {
                cidId = cid2 ? cid2 : cidId
            } else {
                cidId = cid2 ? (`${cidId}, ${cid2}`) : cidId
            }

            if (cidId == '') {
                cidId = ciapCid1 ? ciapCid1 : cidId
            } else {
                cidId = ciapCid1 ? (`${cidId}, ${ciapCid1}`) : cidId
            }

            if (cidId == '') {
                cidId = ciapCid2 ? ciapCid2 : cidId
            } else {
                cidId = ciapCid2 ? (`${cidId}, ${ciapCid2}`) : cidId
            }

            return {
                procedimento: {
                    queryString: {
                        search_by_apelido: this.model.searchByApelido,
                        cbo: this.data.model.cadastro ? this.data.model.cadastro.ocupacaoId : null,
                        competencia: this.competencia,
                        cid_id: cidId
                    }
                }
            }
        },
        competencia() {

            if (this.data.model.cadastro && this.data.model.cadastro.dataUsuarioResponsavel) {

                return moment(this.data.model.cadastro.dataUsuarioResponsavel).format('YYYYMM')
            }

            return ''
        },
        field() {

            return {
                autocompletes: {
                    procedimento: this.model.searchByApelido
                        ? [{ key: 'parametrizacao_procedimento.apelido', searchable: true }]
                        : [{ key: 'nome', searchable: true }, { key: 'codigo', searchable: true }],
                }
            }

        },
        fields() {
            return [
                {
                    key: "codigo",
                    label: "Código",
                    class: "col-min",
                },
                {
                    key: "nome",
                    label: "Procedimento",
                },
                {
                    key: "actions",
                    label: "Ações",
                    class: "col-min",
                },
            ]
        },
        items() {

            const pacienteId = this.data.model.procedimentosIndividuais.find(paciente => paciente.pacienteId == this.item.id)

            if(pacienteId) { 
                return this.data.model.procedimentosIndividuais.filter(a => a.pacienteId == this.item.id)
            } else {
                return []
            }

        },  
        validations() {

            return {
                procedimento: {
                    required: true
                },
            }
        },
    },
    created() {

        this.repositories = {
            atividadeColetiva: this.getConectaSusRepository('atencaoBasica.atividadeColetiva'),
            procedimento: this.getConectaSusRepository('sigtap.procedimento'),
        }

    },
    data: () => ({
        model: {
            procedimentosIndividuais: null,
            procedimentoIndividual: null,
            searchByApelido: false,
        },
        index: null,
        item: [],
        enums: {
            procedimento,
        }
    }),
    methods: {
        open(index, item) {
            this.item = item

            this.$refs.RkmModal.show()
        },
        save() {

            if(this.model.procedimentoIndividual) {

                const pacienteId = this.data.model.procedimentosIndividuais.find(paciente => paciente.pacienteId == this.item.id)
                const procedimentoIndividual = this.data.model.procedimentosIndividuais.find(procedimentoIndividual => procedimentoIndividual.id == this.model.procedimentoIndividual.id)

                if (procedimentoIndividual && pacienteId) {

                    this.showAlert('O procedimento já foi cadastrado anteriormente para este paciente.', "Atenção")
                    return false
                    
                }

                const param = {
                    id: this.model.procedimentoIndividual.id,
                    procedimentoId: this.model.procedimentoIndividual.id,
                    nome: this.model.procedimentoIndividual.nome,
                    codigo: this.model.procedimentoIndividual.codigo,
                    pacienteId: this.item.id
                }

                if (this.index !== null) {
                    this.$set(this.data.model.procedimentosIndividuais, this.index, this.clone(param))
                } else {
                    this.data.model.procedimentosIndividuais.push(this.clone(param))
                }

                this.$emit('procedimentosIndividuais', this.data.model.procedimentosIndividuais)

                this.resetForm()

            }
        },
        resetForm() {

            this.model.procedimentoIndividual = null
        },
        handleCancel() {

            this.resetForm()
            this.$refs.RkmModal.hide()
        },
        destroy(index) {

            const destroy = async () => this.data.model.procedimentosIndividuais.splice(index, 1)

            this.showDeleteConfirmation('Deseja realmente excluir o procedimento individual?', destroy)
        }
    },
    mixins: [ repository, stringCase, object, formats ],
    filters: {
        formatProcedimento: formats.formatProcedimento,
    },
    props: {
        data: { type: Object, required: true },
    }
}
</script>

<style scoped>
.warning {
    color: var(--warning);
}
</style>